import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Tag } from 'ui/tags';
import { Body2, colors, duration, easing, spacing, Subtitle1 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const LogoContainer = styled.div`
  grid-area: image;
  display: flex;
  padding: ${spacing.half};
  border-radius: ${spacing.quarter};
`;

export const Title = styled.div`
  grid-area: title;
  align-items: center;
  display: inline-flex;
  justify-content: start;
`;

export const Name = styled(Subtitle1)`
  margin-bottom: 0;
  margin-right: ${spacing.quarter};
  margin-top: 0;
`;

export const Description = styled(Body2)`
  color: ${colors.textSecondary};
  grid-area: description;
  margin-bottom: 0;
`;

export const CategoryTag = styled(Tag)`
  padding-left: ${spacing.half};
  padding-right: ${spacing.half};
`;

export const ArrowContainer = styled.div`
  align-items: center;
  display: flex;
  grid-area: arrow;
  transition: transform ${duration.medium} ${easing.standard};
`;

export const Wrapper = styled(Link)`
  background-color: ${colors.white};
  display: grid;
  grid-column-gap: ${spacing.base};
  grid-template-areas: 'image title arrow' 'image description arrow';
  grid-template-columns: auto 1fr auto;
  padding: ${spacing.base} ${spacing.plusHalf};

  &:not(:last-of-type) {
    border-bottom: ${spacing.single} solid ${colors.grey15};
  }

  &:hover {
    ${ArrowContainer} {
      transform: translateX(${pxToRem(10)});
    }
    text-decoration: none;
  }
`;
